import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4888dad9"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ODadosNaoEncontrados" }
const _hoisted_2 = { class: "ODadosNaoEncontrados__MensagemBotao" }
const _hoisted_3 = { class: "ODadosNaoEncontrados__Mensagem" }

import PButton from "primevue/button"
  import Avatar from "primevue/avatar"

  interface Props {
    mensagem: string
    textoBotao?: string
    iconeAvatar: string
    dataTestId?: string
  }
  
export default /*#__PURE__*/_defineComponent({
  __name: 'ODadosNaoEncontrados',
  props: {
    mensagem: null,
    textoBotao: null,
    iconeAvatar: null,
    dataTestId: { default: "ODadosNaoEncontrado__ExibirFormUsuario" }
  },
  emits: ["onAcao"],
  setup(__props: any, { emit: emitir }: { emit: ({
    (event: "onAcao"): void
  }), expose: any, slots: any, attrs: any }) {

  

  
  const onClicarNoBotao = () => {
    emitir("onAcao")
  }

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(Avatar), {
      class: "ODadosNaoEncontrado__Avatar",
      icon: 'pi ' + __props.iconeAvatar,
      shape: "circle",
      size: "xlarge"
    }, null, 8, ["icon"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("p", null, _toDisplayString(__props.mensagem), 1)
      ]),
      (__props.textoBotao)
        ? (_openBlock(), _createBlock(_unref(PButton), {
            key: 0,
            onClick: onClicarNoBotao,
            class: "ODadosNaoEncontrado__Botao p-button-warning",
            "data-testid": __props.dataTestId,
            label: __props.textoBotao
          }, null, 8, ["data-testid", "label"]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})